import { registerAction } from '../../Action'

const REMOVE_PLACEMENT = 'REMOVE_PLACEMENT'

const reducer = (state = {}, action) => {
  const placements = { ...state.jsonApiEntities.placement }
  delete placements[action.payload]
  return {
    ...state,
    jsonApiEntities: { ...state.jsonApiEntities, placement: placements },
  }
}

const removePlacement = registerAction(REMOVE_PLACEMENT, { reducer })

export default removePlacement
